import { Box, styled } from '@creditas-ui/react'
import React, { Children, cloneElement } from 'react'

const AccordionHeader = ({ children, isOpen, ...props }) => {
  const AccordionHeaderStyle = styled(Box)`
    position: relative;
    background-color: ${({ theme }) =>
      isOpen ? theme.colors.neutral[10] : ''};

    .warrantyIcon {
      background-color: ${({ theme }) =>
        isOpen ? theme.colors.neutral[0] : ''};
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.neutral[10]};

      .warrantyIcon {
        background-color: ${({ theme }) => theme.colors.neutral[0]};
      }
    }

    & td:nth-of-type(1) {
      padding: 24px 0px 24px 44px
    }
    & td:nth-of-type(2) {
      padding: 24px;
    }
    & td:nth-of-type(3) {
      display: none;
    }
    & td:nth-of-type(4) {
      display: none;
    }
    & td:nth-of-type(5) {
      display: none;
    }

    @media screen and (min-width: 980px) {
      & td:nth-of-type(1) {
        padding: inhenrit;
      }
      & td:nth-of-type(2) {
        padding: inhenrit;
      }
      & td:nth-of-type(3) {
        display: block;
      }
      & td:nth-of-type(4) {
        display: block;
      }
      & td:nth-of-type(5) {
        display: block;
      }
    }
  `
  return (
    <AccordionHeaderStyle {...props}>
      {Children.map(children, child => {
        return cloneElement(child, {
          isOpen,
        })
      })}
    </AccordionHeaderStyle>
  )
}

export { AccordionHeader }
